export function GetValueFromInputElement(id: string): string | null {
	const element = document.getElementById(id) as HTMLInputElement | null;
	if (element && element.value) {
		return element.value;
	}
	return null;
}
